import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateSellerLeadStatus } from "@/lib/api/seller-leads.api"
import { useAuthStore } from "@/store/auth.store"

export function useUpdateSellerLeadStatus() {
  const { accessToken } = useAuthStore()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: { status: string; message: string } }) => {
      if (!accessToken) throw new Error("Not authenticated")
      const response = await updateSellerLeadStatus(id, payload, accessToken)
      return response.data
    },
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ["seller-leads"] })
      queryClient.invalidateQueries({ queryKey: ["seller-leads-count"] })
      queryClient.invalidateQueries({ queryKey: ["seller-lead", id] })
    },
  })
}
